import _ from 'lodash'
import { withAddresses } from '../addresses'
import { withAuth } from '../auth'
import { withBackInStockNotifications } from '../back-in-stock-notifications'
import { withBeautyAssistantSessions } from '../beauty-assistant-sessions'
import { withCart } from '../cart'
import { withCartShipments } from '../cart-shipments'
import { withCacheChecksum } from '../cache'
import { withCategories } from '../categories'
import { withCommerceChannels } from '../commerce-channels'
import { withContentGroups } from '../content-groups'
import { withCoupons } from '../coupons'
import { withCouponTokens } from '../coupon-tokens'
import { withCouponUsages } from '../coupon-usages'
import { withCurrencies } from '../currencies'
import { withDataBins } from '../data-bins'
import { withDeliveryAddresses } from '../delivery-addresses'
import { withDineInCart } from '../dine-in-cart'
import { withDisableCheckouts } from '../disable-checkouts'
import { withFavourites } from '../favourites'
import { withI18n } from '../i18n'
import { withMetaDefinitions } from '../meta-definitions'
import { withOrders } from '../orders'
import { withOmnitechApp } from './shared'
import { withPages } from '../pages'
import { withPayment } from '../payment'
import { withPhones } from '../phones'
import { withProductGroups } from '../product-groups'
import { withProducts } from '../products'
import { withProductDetailAttr } from '../product-detail-attr'
import { withDepartments } from '../departments'
import { withRecommendations } from '../recommendations'
import { withReviews } from '../reviews'
import { withSkus } from '../skus'
import { withStockCounters } from '../stock-counters'
import { withSystemSettings } from '../system-settings'
import { withUser } from '../users'
import { withStores } from '../stores'
import { withColorMasters } from '../color-masters'
import { withBrands } from '../brands'
import { withSizeMasters } from '../size-masters'
import { withArticles } from '../articles'
import { withArticlesCategories } from '../articles-categories'
import { withAttachment } from '../attachment'
import { withSupportTicket } from '../support-ticket'
import { withLoyaltyPointTransactions } from '../loyalty-point-transactions'
import { withOrderMethod } from '../order-method'
import { withStaffs } from '../staffs'
import { withClasses } from '../classes'
import { withBookings } from '../bookings'
import { withSkuQuotaMasters } from '../sku-quota-masters'
import { withStoredValueTransactions } from '../stored-value-transactions'

// compose all provider from modules
const withComposedProvider = _.flowRight([
  // withAuth should be put in the first one which init api client security header.
  // if the module has dependencies, please put its lower than the dependencies
  withI18n,
  withAuth,
  withBackInStockNotifications,
  withBeautyAssistantSessions,
  withCacheChecksum,
  withSystemSettings,
  withOmnitechApp,
  withCart,
  withCartShipments,
  withCoupons,
  withCouponTokens,
  withCouponUsages,
  withCurrencies,
  withDataBins,
  withDeliveryAddresses,
  withDineInCart,
  withDisableCheckouts,
  withFavourites,
  withUser,
  withPages,
  withPhones,
  withProductGroups,
  withProducts,
  withProductDetailAttr,
  withAddresses,
  withDepartments,
  withCategories,
  withCommerceChannels,
  withContentGroups,
  withSkus,
  withStockCounters,
  withOrders,
  withPayment,
  withRecommendations,
  withReviews,
  withStores,
  withColorMasters,
  withBrands,
  withSizeMasters,
  withArticles,
  withArticlesCategories,
  withMetaDefinitions,
  withAttachment,
  withSupportTicket,
  withLoyaltyPointTransactions,
  withOrderMethod,
  withStaffs,
  withClasses,
  withBookings,
  withSkuQuotaMasters,
  withStoredValueTransactions,
])

export default withComposedProvider
